import React from 'react'

import { CharacterPageProps } from './interface'

export function withCharacterPage(Component: React.FC<CharacterPageProps>) {
  function WithCharacterPage(props: CharacterPageProps) {
    return <Component {...props} />
  }
  return WithCharacterPage
}
